// Imported from the defining module, not the barrel, which re-exports this file and would form a cycle.
import { config } from "./env";

export const ENABLE_DECISION_FLOWS = config?.DECISION_FLOWS === "true" || import.meta.env.DEV;
export const ENABLE_UPDATE_ENTITY_REFERENCES = config?.UPDATE_ENTITY_REFERENCES === "true" || import.meta.env.DEV;
export const ENABLE_NEW_SCENARIO_IMPORT_UI = config?.NEW_SCENARIO_IMPORT_UI !== "false" || import.meta.env.DEV;
// @ts-ignore
export const DISABLE_MAPPINGS_PAGE = true;

export const FORCE_TENANCY = config?.FORCE_TENANCY;
export const ENABLE_INTERNAL_DEBUGGER = config?.INTERNAL_DEBUGGER === "true" || import.meta.env.DEV;
